function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .8h14v14H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 .8c3.87 0 7 3.131 7 7 0 3.87-3.131 7-7 7-3.87 0-7-3.131-7-7 0-3.87 3.131-7 7-7zm0 1.094A5.903 5.903 0 001.094 7.8 5.903 5.903 0 007 13.706 5.903 5.903 0 0012.906 7.8 5.903 5.903 0 007 1.894zM4.047 4.846a.5.5 0 01.707 0l2.272 2.275 2.272-2.274a.5.5 0 01.766.637l-.058.07-2.274 2.275 2.274 2.276.058.07a.5.5 0 01-.766.637L7.026 8.536l-2.272 2.276a.5.5 0 01-.766-.638l.058-.069L6.32 7.83 4.046 5.553l-.058-.069a.5.5 0 01.059-.638z",
  fill: "#D24667"
}))));